// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"0865a006","72":"0c3ff941","113":"95ca01d2","123":"ea44efe4","171":"834d1639","324":"a8b3d869","330":"bf682a93","352":"77c70ce0","397":"333bb04b","462":"227dc22f","521":"b5598d6e","570":"bf365163","925":"404f764d","990":"55d5d16f"}[chunkId] + ".chunk.js";
};